const placaMask = [
  /[a-zA-Z]/,
  /[a-zA-Z]/,
  /[a-zA-Z]/,
  /\d/,
  /[a-zA-Z0-9]/,
  /\d/,
  /\d/
];

export default placaMask;



// WEBPACK FOOTER //
// ./src/components/Masks/Placa.js